import { render, staticRenderFns } from "./WFooterLink.vue?vue&type=template&id=3e055949&scoped=true&"
import script from "./WFooterLink.vue?vue&type=script&lang=js&"
export * from "./WFooterLink.vue?vue&type=script&lang=js&"
import style0 from "./WFooterLink.vue?vue&type=style&index=0&id=3e055949&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e055949",
  null
  
)

export default component.exports